<template>
  <div>
    <div class="uk-card-body dcs-section-header">Select Delivery Preference</div>
    <div class="uk-card-body">
      <delivery-method-form
        :theme="theme"
        :law="law"
        :delivery-method.sync="delivery.delivery_method"
        :email-address.sync="delivery.email_address"
        :mailing-address.sync="delivery.mailing_address"
        @validated="onDeliveryValidated"
      />

      <div class="uk-margin uk-text-center">
        <p>
          <content-section :content-key="'submission-disclaimer-' + $parent.requestType" :law="law"/>
        </p>
        <div v-if="submitting" class="three-quarters-loader"></div>
        <input
          v-else
          type="submit"
          class="uk-button uk-button-primary uk-button-large uk-width-1-2 dcs-button"
          value="Submit"
          :disabled="!canSubmit"
          @click="submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryMethodForm from "./DeliveryMethodForm";
import ContentSection from "./elements/ContentSection";
import * as sentry from "@sentry/vue";
import { datadogRum } from "@datadog/browser-rum";

export default {
  name: "request-page",
  components: {
    DeliveryMethodForm,
    ContentSection
  },
  props: ["theme", "client", "requestUUID", "law"],
  data: function() {
    return {
      delivery: {
        delivery_method: "email",
        email_address: null,
        mailing_address: { country: "USA" },
        valid: false
      },
      submitting: false
    };
  },
  computed: {
    canSubmit: function() {
      return (
        this.delivery.delivery_method != null && this.delivery.valid == true
      );
    }
  },
  methods: {
    onDeliveryValidated: function(v) {
      this.delivery.valid = !v.$invalid;
    },
    submit: function() {
      this.$emit("willSubmit");
      this.submitting = true;

      const requestData = {
        delivery_method:
          this.delivery.delivery_method == "email" ? "email" : "snail_mail",
        email_address: this.delivery.email_address,
        mailing_address: this.delivery.mailing_address
      };

      this.client
        .post(`requests/${this.requestUUID}/delivery_method`, requestData)
        .then(response => {
          if (response.success === true) {
            this.$emit("complete", this.delivery.delivery_method);
            datadogRum.addAction("DataCompliance.RequestPage.Submit.Success", { method: this.delivery.delivery_method });
          } else {
            // will kick back to home page: this.$emit("deliveryDataMismatch");
            datadogRum.addAction("DataCompliance.RequestPage.Submit.Error", { error: "Delivery data mismatch" });
            this.$emit("error", "delivery-data-mismatch");
            this.submitting = false;
          }
        })
        .catch((error) => {
          sentry.captureMessage(`${error}`, { level: "error", extra: { stack: error.stack } });
          datadogRum.addAction("DataCompliance.RequestPage.Submit.Error", { error: `${error}`, stack: error.stack });

          this.$emit("error", "server-error");
          this.submitting = false;
        });
    }
  }
};
</script>

<style scoped></style>
